module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("经办人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.applicantName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fillDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("职务")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.rankName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("借款信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.recCode))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据状态")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.loanStatus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属业务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.businessName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用途")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.loanReason))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款金额（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.loanMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("借款金额（大写）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.loanMoneyDaxie))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预计还款日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.willReturnDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("收款人信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款人/单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payee))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款银行")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.loanBankName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.loanBankNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name detail-page-remark",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("财务处理信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("记账单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.faccountUnit))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payType))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款银行")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payBankName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款账户")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payBankNo))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cca712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/finance/loan.vue
// module id = ij8d
// module chunks = 1